<template>
    <div
        :class="{
            'w-100': !inline
        }"
    >
        <dropdown-popper-wrapper
            :popup-used-in-modal="popupUsedInModal"
            :vuetify-component-ref-get="() => $refs.component"
        >
            <template #default="{ attachGet, menuProps }">
                <v-autocomplete
                    ref="component"
                    :aria-label="ariaLabel || label || placeholder"
                    :attach="attachGet()"
                    :class="{
                        'input-select-inline': inline,
                        'input-appended-floating': !inline,
                    }"
                    :menu-props="menuProps"
                    dense
                    hide-details="auto"
                    outlined
                    @input="resetInput()"
                    :search-input.sync="localSearchInput"

                    v-bind="{...$attrs, ...$props}"
                    v-on="$listeners"
                >
                    <!-- https://stackoverflow.com/a/66062466 - pass through scoped slots -->
                    <template v-for="(_, scopedSlotName) in $scopedSlots"
                              v-slot:[scopedSlotName]="slotData">
                        <slot :name="scopedSlotName"
                              v-bind="slotData" />
                    </template>

                    <template v-for="(_, slotName) in $slots"
                              v-slot:[slotName]>
                        <slot :name="slotName" />
                    </template>
                </v-autocomplete>
            </template>
        </dropdown-popper-wrapper>
    </div>
</template>

<script>
import DropdownPopperWrapper from '../dropdown-popper-wrapper.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    components: { DropdownPopperWrapper },
    props: {

        popupUsedInModal: Boolean,
        inline: Boolean,

        ariaLabel: String,
        label: String,
        placeholder: String,
        items: {
            type: Array,
            required: true
        },
        prefix: String,
        value: {
            required: true
        },
        disabled: Boolean,

        /* V-Autocomplete props */
        autoSelectFirst: Boolean,
        filter: Function,
        hideNoData: Boolean,
        noFilter: Boolean,
        searchInput: String,

        /* V-Select props */
        appendIcon: String,
        // 'attach' is handled by this wrapper component, should not be allowed as a prop
        // attach: {
        //     default: false,
        // },
        cacheItems: Boolean,
        chips: Boolean,
        clearable: Boolean,
        deletableChips: Boolean,
        disableLookup: Boolean,
        eager: Boolean,
        hideSelected: Boolean,
        itemColor: String,
        itemDisabled: [String, Array, Function],
        itemText: [String, Array, Function],
        itemValue: [String, Array, Function],
        menuProps: [String, Array, Object],
        multiple: Boolean,
        openOnClear: Boolean,
        returnObject: Boolean,
        smallChips: Boolean,

        /* V-TextField props */
        appendOuterIcon: String,
        autofocus: Boolean,
        clearIcon: String,
        counter: [Boolean, Number, String],
        counterValue: Function,
        filled: Boolean,
        flat: Boolean,
        fullWidth: Boolean,
        outlined: Boolean,
        prependInnerIcon: String,
        persistentPlaceholder: Boolean,
        reverse: Boolean,
        rounded: Boolean,
        shaped: Boolean,
        singleLine: Boolean,
        solo: Boolean,
        soloInverted: Boolean,
        suffix: String,
        type: String,

        /* V-Input props */
        backgroundColor: String,
        dense: Boolean,
        height: [Number, String],
        hideDetails: [Boolean, String],
        hideSpinButtons: Boolean,
        hint: String,
        id: String,
        loading: Boolean,
        persistentHint: Boolean,
        prependIcon: String,

        /* vuetify 'comparable' props */
        valueComparator: Function,

        /* vuetify 'filterable' props */
        noDataText: String,

        /* vuetify 'validatable' props */
        error: Boolean,
        errorCount: {
            type: [Number, String],
            default: 1
        },
        errorMessages: [String, Array],
        messages: [String, Array],
        readonly: Boolean,
        rules: Array,
        success: Boolean,
        successMessages: [String, Array],
        validateOnBlur: Boolean,

        /* vuetify 'colorable' props */
        color: String,

        /* vuetify 'themeable' props */
        dark: Boolean,
        light: Boolean,

        /* vuetify 'loadable' props */
        loaderHeight: [Number, String]
    },
    data: function () {
      return {
        localSearchInput: this.searchInput,
      }
    },
    watch: {
      searchInput: function (val) {
        this.localSearchInput = val;
      },
      localSearchInput(val) {
        this.$emit("update:searchInput", val);
      }
    },
    methods: {
      resetInput: function () {
        this.$nextTick(function () {
          this.localSearchInput = "";
          this.$emit('update:searchInput', "");
       })
     }
    }
});
</script>
